// frontend/src/components/library/CategoriesGrid.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Loader2 } from 'lucide-react'; 
import { fetchBookCategories } from '../../services/bookService'; 

const STATIC_STYLES = [
    { gradient: "bg-gradient-to-br from-emerald-600 to-emerald-800", text: "text-white", hover: "hover:scale-105", width: "35%" },
    { gradient: "bg-gradient-to-br from-teal-500 to-teal-700", text: "text-white", hover: "hover:scale-105", width: "65%" },
    { gradient: "bg-gradient-to-br from-sky-500 to-sky-700", text: "text-white", hover: "hover:scale-105", width: "50%" },
    { gradient: "bg-gradient-to-br from-blue-500 to-blue-700", text: "text-white", hover: "hover:scale-105", width: "50%" },
    { gradient: "bg-gradient-to-br from-indigo-600 to-indigo-800", text: "text-white", hover: "hover:scale-105", width: "65%" },
    { gradient: "bg-gradient-to-br from-violet-700 to-violet-900", text: "text-white", hover: "hover:scale-105", width: "35%" },
    { gradient: "bg-gradient-to-br from-purple-700 to-purple-900", text: "text-white", hover: "hover:scale-105", width: "50%" },
    { gradient: "bg-gradient-to-br from-fuchsia-800 to-fuchsia-950", text: "text-white", hover: "hover:scale-105", width: "50%" },
];

const CategoriesGrid = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadCategories = async () => {
            try {
                const response = await fetchBookCategories();
                let fetchedData = Array.isArray(response.data)
                    ? response.data
                    : response.data?.results || [];
                
                // ✅ فقط دسته‌بندی‌های سطح اصلی (بدون والد) را نگه دار
                let mainCategories = fetchedData.filter(cat => cat.parent === null);
                
                // 🟢 جابجایی دسته‌بندی‌ها: "جامعه‌شناسی، علومِ سیاسی و فلسفه‌یِ سیاست" با "دین"
                const sociologyIndex = mainCategories.findIndex(cat => 
                    cat.slug === 'politicsandsociality' || 
                    cat.name === 'جامعه‌شناسی، علومِ سیاسی و فلسفه‌یِ سیاست'
                );
                const religionIndex = mainCategories.findIndex(cat => 
                    cat.slug === 'religious' || 
                    cat.name === 'دین'
                );
                
                if (sociologyIndex !== -1 && religionIndex !== -1) {
                    // جابجایی دو عنصر
                    [mainCategories[sociologyIndex], mainCategories[religionIndex]] = 
                    [mainCategories[religionIndex], mainCategories[sociologyIndex]];
                }
                
                setCategories(mainCategories.slice(0, 9)); 
            } catch (error) {
                console.error("خطا در واکشی دسته‌بندی‌های کتاب:", error);
                setCategories([]);
            } finally {
                setLoading(false);
            }
        };
        loadCategories();
    }, []);

    if (loading) {
        return (
            <div className="w-full p-10 flex justify-center items-center h-48 bg-white rounded-xl">
                <Loader2 className="animate-spin text-indigo-600" size={40} />
            </div>
        );
    }
    
    if (categories.length === 0) {
        return <p className="text-center text-gray-500 p-2 bg-white rounded-l">دسته‌بندی‌‌ای برای نمایش یافت نشد.</p>;
    }

    return (
        <div className="w-full bg-white rounded-l overflow-hidden">
            <div className="flex flex-wrap">
                {categories.map((category, index) => {
                    const style = STATIC_STYLES[index % STATIC_STYLES.length];
                    const inlineStyle = {
                        width: style.width,
                        padding: '0.2rem',
                    };
                    const innerClassNames = `
                        flex flex-col items-center justify-center 
                        p-4 h-24 
                        ${style.gradient} 
                        ${style.text}
                        ${style.shadow}
                        rounded-lg
                        transition-all duration-200
                        transform hover:${style.hover}
                        w-full h-full
                    `;
                    return (
                        <Link 
                            to={`/books?category__slug=${category.slug}`} 
                            key={category.slug}
                            style={inlineStyle} 
                            className="transition-transform duration-200 transform hover:scale-[1.03]"
                        >
                            <div className={innerClassNames}>
                                <span className="text-[11px] font-medium text-center max-w-full">
                                    {category.name || category.title}
                                </span>
                            </div>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};

export default CategoriesGrid;